import blockTemplates from './block-templates';

export default {
  blockTemplates,
};
